var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.235,
    height: 26.404,
    viewBox: "0 0 31.235 30.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12932.504 -6639.871)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12932.504 6639.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.419,43.067c3.172,0,5.744-3.124,5.744-6.977s-.844-6.977-5.744-6.977-5.744,3.124-5.744,6.977S130.247,43.067,133.419,43.067Z",
    transform: "translate(-122.57 -29.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.316,206.532c-.106-6.712-.983-8.625-7.691-9.836a4.712,4.712,0,0,1-6.29,0c-6.635,1.2-7.565,3.082-7.687,9.617-.01.534-.015.562-.016.5,0,.116,0,.331,0,.705,0,0,1.6,3.22,10.848,3.22s10.848-3.22,10.848-3.22c0-.241,0-.408,0-.522A4.183,4.183,0,0,1,90.316,206.532Z",
    transform: "translate(-68.631 -182.208)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12915.384 6655.643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.217,20.729a5.136,5.136,0,0,0,.066-.663,5.37,5.37,0,0,0-.066-.663l1.273-.964a.707.707,0,0,0,.185-.917l-1.143-1.979a.707.707,0,0,0-.886-.3l-1.465.618a5.25,5.25,0,0,0-1.157-.688l-.2-1.556a.708.708,0,0,0-.7-.619H18.842a.707.707,0,0,0-.7.619l-.2,1.556a5.272,5.272,0,0,0-1.157.688l-1.465-.618a.705.705,0,0,0-.886.3l-1.143,1.979a.708.708,0,0,0,.185.917l1.273.964a5.135,5.135,0,0,0-.066.663,5.371,5.371,0,0,0,.066.663l-1.273.964a.707.707,0,0,0-.185.917l1.143,1.98a.707.707,0,0,0,.886.3l1.465-.619a5.25,5.25,0,0,0,1.157.688l.2,1.556a.705.705,0,0,0,.7.619h2.285a.707.707,0,0,0,.7-.619l.2-1.556a5.273,5.273,0,0,0,1.157-.688l1.465.618a.705.705,0,0,0,.886-.3l1.143-1.98a.708.708,0,0,0-.185-.917Zm-5.233,2.164a2.826,2.826,0,1,1,2.826-2.826A2.826,2.826,0,0,1,19.984,22.893Z",
    transform: "translate(-13.199 -13)",
    fill: "#fff",
    stroke: "#008bff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSettings);
export default __webpack_public_path__ + "static/media/Account Settings.9edbc51bfd77d443ba607dac7d0840ba.svg";
export { ForwardRef as ReactComponent };